
import { ContactPanelState } from './types';

export const state = (): ContactPanelState => initialState();

export const initialState = (): ContactPanelState => ({
  contactPanels: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 100,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['ActionEmailMessage'],
      andClauseFieldsIds: [],
    },
  },
});
